<template>
  <span>
    {{ getHumanDate() }}
  </span>
</template>

<script>
export default {
  name: "ChatDateTime",
  props: {
    date: {
      required: true,
      type: String,
    },
  },
  methods: {
    getHumanDate: function() {
      if (
        this.$moment(this.date).format("DD") ===
        this.$moment(new Date()).format("DD")
      ) {
        return this.$moment(this.date)
          .tz("Asia/Bangkok")
          .format("HH:mm");
      } else if (
        this.$moment(this.date).isSame(this.$moment().subtract(1, "day"), "day")
      ) {
        return (
          this.$t("yesterday") +
          ", " +
          this.$moment(this.date)
            .tz("Asia/Bangkok")
            .format("HH:mm")
        );
      } else if (
        this.$moment(this.date).format("YYYY") ===
        this.$moment(new Date()).format("YYYY")
      ) {
        return this.$moment(this.date)
          .tz("Asia/Bangkok")
          .format("DD MMM, HH:mm");
      } else {
        return this.$moment(this.date)
          .tz("Asia/Bangkok")
          .format("DD MMM YYYY");
      }
    },
  },
  data() {
    return {};
  },
  created: async function() {},
};
</script>

<style lang="scss" scoped>
@media (max-width: 767.98px) {
}
</style>
